import React, { useContext, useState } from 'react'
import { IoBagHandle, IoPlanet, IoPricetag, IoResize, IoTabletLandscapeOutline } from 'react-icons/io5'
import PopupBg from './PopupBg'
import { CartContext } from '../Contexts/CartContext'

const AddCartPopup = ({ closeModal, showAlert, mangoe, action }) => { // action: add || update
  // STATES
  const [ quantity, setQuantity ] = useState(mangoe.quantity || '');
  const [ caliber, setCaliber ] = useState(mangoe.caliber || 5);
  const [ total_price, setTotal_price ] = useState(mangoe.total_price || 0);

  // CONTEXTS
  const { addToCart, editCart } = useContext(CartContext);

  const handleQuantity = (e) => {
    const q = e.target.value;
    let tp = 2.5 * q;
      
    setQuantity(q);
    setTotal_price(tp)
  }

  const addItem = (e) => {
    e.preventDefault();

    if(quantity > 0){
      const item = {...mangoe, quantity, caliber, total_price};
      action == "add" ? addToCart(item) : editCart(mangoe.mango_id, {caliber, quantity});
      closeModal();
      showAlert();
    }
  }

  return (
    <div id="custom">
      <PopupBg opacity="transparent" closeModal={closeModal}>
        <div className="AddCartPopup">

          <div className="productbox">
            <div className="close" onClick={closeModal}>+</div>
            <img src={mangoe.image_url} alt="Mangue" />
            <h3>Variété : <span>{mangoe.variety}</span></h3>
            <p>
              {mangoe.description}
            </p>
          </div>

          <form onSubmit={addItem}>
            <p className="form-box">
              <span className="icon"><IoBagHandle /></span>
              <label htmlFor='quantite'>Quantité (en Kg)</label>
              <input
                type="number"
                id='quantite'
                placeholder='ex: 128'
                value={quantity}
                onChange={handleQuantity}
              />
            </p>

            <p className="form-box">
              <span className="icon"><IoResize /></span>
              <label htmlFor='caliber'>Caliber</label>
              <select name="caliber" id="caliber"
                value={caliber}
                onChange={e => setCaliber(e.target.value)}
              >
                <option value="14">14 (300 - 350g)</option>
                <option value="12">12 (351 - 400g)</option>
                <option value="10">10 (401 - 450g)</option>
                <option value="9">9 (451 - 500g)</option>
                <option value="8">8 (501 - 600g)</option>
                <option value="7">7 (601 - 650g)</option>
                <option value="6">6 (651 - 700g)</option>
                <option value="5">5 (751 - 750g)</option>
              </select>
            </p>

            <div className="validate">
              <div className="amount">
                <span className="icon"><IoPricetag /></span>
                <span className="price">{total_price} €</span>
              </div>

              <button
                onClick={addItem}
                className={!quantity ? "disabled" : "anabled"}
              >
                Ajouter au panier
              </button>
            </div>
          </form>

        </div>
      </PopupBg>
    </div>
  )
}

export default AddCartPopup